"use client";

import { Heading, ListProps, OrderedList, SimpleGrid, Stack, UnorderedList } from "@biblioteksentralen/react";
import { DefaultContainer } from "../../../../../../../components/ContentContainer";
import WorkPreview from "../../../../../../../searchAndCollection/components/works/WorkPreview";
import CollectionViewBanner from "../../../../../../../searchAndCollection/components/CollectionViewBanner";
import { useTranslation } from "../../../../../../../utils/hooks/useTranslation";
import { Work } from "@biblioteksentralen/cordata";
import { CollectionMetaData, WorksSortedByNumberInSeries } from "./utils";
import { DefaultPageLayout } from "../../../../../../../components/layout/DefaultPageLayout";

type Props = {
  worksSortedByNumberInSeries: WorksSortedByNumberInSeries;
  collectionMetadata: CollectionMetaData;
};

const SeriesClientSide = ({ worksSortedByNumberInSeries, collectionMetadata }: Props) => {
  const { t } = useTranslation();
  const hasNumberedWorks = worksSortedByNumberInSeries.numberedWorks.length > 0;
  const hasNonNumberedWorks = worksSortedByNumberInSeries.nonNumberedWorks.length > 0;

  return (
    <DefaultPageLayout>
      <DefaultContainer>
        <Stack spacing="2rem">
          <CollectionViewBanner
            worksSortedByNumberInSeries={worksSortedByNumberInSeries}
            collectionMetadata={collectionMetadata}
          />
          {hasNumberedWorks && <WorksGrid works={worksSortedByNumberInSeries.numberedWorks} as={OrderedList} />}
          {hasNumberedWorks && hasNonNumberedWorks && (
            <Heading as={"h3"} size="lg" marginTop="0 !important">
              {t("Andre verk relatert til serien")}
            </Heading>
          )}
          {hasNonNumberedWorks && <WorksGrid works={worksSortedByNumberInSeries.nonNumberedWorks} as={UnorderedList} />}
        </Stack>
      </DefaultContainer>
    </DefaultPageLayout>
  );
};

const WorksGrid = ({ works, ...chakraProps }: { works: Work[] } & Pick<ListProps, "as">) =>
  works.length > 0 && (
    <SimpleGrid spacing="1rem" columns={{ base: 1, lg: 2, xl: 3 }} {...chakraProps}>
      {works.map((work) => (
        <WorkPreview key={work.id} work={work} />
      ))}
    </SimpleGrid>
  );

export default SeriesClientSide;
